export enum DefaultPaperSize {
  LetterPerforatedUline = 'DefaultSize_LetterPerforated_Uline',
  LetterPerforatedAvery = 'DefaultSize_LetterPerforated_Avery',
  LetterLaserLabel = 'DefaultSize_LetterLabels_Uline', // laser cut sticky labels
  LetterLaserLabelAvery = 'DefaultSize_LetterLabel_Avery', // laser cut sticky labels from Avery
  LetterCustomCut = 'DefaultSize_Letter_CustomCut' // regular paper
}
